/*
 * Dynamic Fields Messages
 *
 * This contains all the text for the Dynamic Fields component.
 */

import { defineMessages } from 'react-intl';
export const scope = 'src.pages.DynamicFieldsPage';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Dynamic Fields',
  },
  fieldCategoryDetailsSectionTitle: {
    id: `${scope}.fieldCategoryDetailsSectionTitle`,
    defaultMessage: 'Field Category Details',
  },
  dynamicFieldSectionTitle: {
    id: `${scope}.dynamicFieldSectionTitle`,
    defaultMessage: 'Dynamic Fields',
  },
  yesLabel: {
    id: `${scope}.yesLabel`,
    defaultMessage: 'Yes',
  },
  noLabel: {
    id: `${scope}.noLabel`,
    defaultMessage: 'No',
  },
  nameEnLabel: {
    id: `${scope}.nameEnLabel`,
    defaultMessage: 'Name (en)',
  },
  nameDeLabel: {
    id: `${scope}.nameDeLabel`,
    defaultMessage: 'Name (de)',
  },
  positionLabel: {
    id: `${scope}.positionLabel`,
    defaultMessage: 'Position',
  },
  nameEnColumnLabel: {
    id: `${scope}.nameEnColumnLabel`,
    defaultMessage: 'Name (en)',
  },
  nameDeColumnLabel: {
    id: `${scope}.nameDeColumnLabel`,
    defaultMessage: 'Name (de)',
  },
  labelEnColumnLabel: {
    id: `${scope}.labelEnColumnLabel`,
    defaultMessage: 'Label (en)',
  },
  labelDeColumnLabel: {
    id: `${scope}.labelDeColumnLabel`,
    defaultMessage: 'Label (de)',
  },
  typeColumnLabel: {
    id: `${scope}.typeColumnLabel`,
    defaultMessage: 'Type',
  },
  categoryColumnLabel: {
    id: `${scope}.categoryColumnLabel`,
    defaultMessage: 'Category',
  },
  positionColumnLabel: {
    id: `${scope}.positionColumnLabel`,
    defaultMessage: 'Position',
  },
  questionEnColumnLabel: {
    id: `${scope}.questionEnColumnLabel`,
    defaultMessage: 'Question (en)',
  },
  questionDeColumnLabel: {
    id: `${scope}.questionDeColumnLabel`,
    defaultMessage: 'Question (de)',
  },
  visibleByAdminColumnLabel: {
    id: `${scope}.visibleByAdminColumnLabel`,
    defaultMessage: 'Visible in Staffing',
  },
  visibleByUserColumnLabel: {
    id: `${scope}.visibleByUserColumnLabel`,
    defaultMessage: 'Visible By User',
  },
  optionsColumnLabel: {
    id: `${scope}.optionsColumnLabel`,
    defaultMessage: 'Options',
  },
  deleteDynamicFieldConfirmMessage: {
    id: `${scope}.deleteDynamicFieldConfirmMessage`,
    defaultMessage: 'Are you sure you want to delete this Field?',
  },
  deleteTooltip: {
    id: `${scope}.deleteTooltip`,
    defaultMessage: 'Delete',
  },
  dynamicFieldDeleted: {
    id: `${scope}.dynamicFieldDeleted`,
    defaultMessage: 'Field deleted successfully',
  },
  dynamicFieldSaved: {
    id: `${scope}.dynamicFieldSaved`,
    defaultMessage: 'Field saved successfully',
  },
  dynamicOptionSaved: {
    id: `${scope}.dynamicOptionSaved`,
    defaultMessage: 'Selectable value (option) saved successfully',
  },
  dynamicOptionDeleted: {
    id: `${scope}.dynamicOptionDeleted`,
    defaultMessage: 'Selectable value (option) deleted successfully',
  },
});
